<template>
  <div
    class="flex items-center justify-start gap-2 overflow-hidden rounded-lg py-3.5"
  >
    <div class="relative size-5 shrink-0 overflow-hidden text-neutral-900">
      <Icon
        name="circle-parking"
        class="block size-full"
        aria-hidden="true"
      />
    </div>
    <div class="flex flex-col justify-center leading-none">
      <slot />
    </div>
  </div>
</template>

<script setup>
import Icon from '@/Shared/Icon.vue';
</script>
